// AUTO-GENERATED by scripts/gen-registry-meta.ts — do not edit by hand.
import type { ComparePost } from "./registry";

export interface CompareMeta {
  slug: string;
  title: string;
  metaTitle: string;
  metaDesc: string;
  category: ComparePost["category"];
  tldr: string;
  updatedAt: string;
  aName: string;
  bName: string;
}

export const COMPARE_CATEGORY_LABELS: Record<ComparePost["category"], string> = {
  "visa": "Visa & Immigration",
  "translation": "งานแปลรับรอง",
  "notary": "Notary Public",
  "legalization": "MFA / กงสุล / Apostille",
  "marriage": "จดทะเบียนสมรส"
};

export const COMPARE_META: CompareMeta[] = [
  {
    "slug": "dtv-vs-ltr-visa",
    "title": "DTV vs LTR Visa — เลือกอันไหนดี?",
    "metaTitle": "DTV vs LTR Visa ต่างกันยังไง 2026 — ตารางเทียบครบ",
    "metaDesc": "เทียบ DTV (Destination Thailand Visa) กับ LTR (Long-Term Resident) ครบทุกมิติ — ราคา, รายได้, ระยะเวลา, ภาษี, สิทธิครอบครัว, เหมาะกับใคร พร้อมคำแนะนำ.",
    "category": "visa",
    "tldr": "DTV เหมาะกับ Digital Nomad ที่ทำงานออนไลน์ — ค่าธรรมเนียม 10,000 บาท, อยู่ครั้งละ 180 วัน, ต่อได้ 5 ปี. LTR เหมาะกับผู้บริหาร/Investor/ผู้เกษียณรายได้สูง — รายได้ 80,000+ USD/ปี หรือลงทุน 500,000+ USD, อยู่ได้ 10 ปี, ลด PIT เหลือ 17% สำหรับ HSP.",
    "updatedAt": "2026-06-03",
    "aName": "DTV (Destination Thailand Visa)",
    "bName": "LTR Visa (Long-Term Resident)"
  },
  {
    "slug": "naati-vs-moj-translation",
    "title": "NAATI vs MoJ (กระทรวงยุติธรรม) — แปลรับรองแบบไหนใช้ที่ไหน",
    "metaTitle": "NAATI vs MoJ Translator — ใช้แบบไหนสำหรับ Visa/ราชการ",
    "metaDesc": "เทียบ NAATI (ออสเตรเลีย) กับ MoJ (กระทรวงยุติธรรมไทย) — เอกสารแบบไหนต้องใช้แบบไหน ค่าใช้จ่าย ระยะเวลา การรับรอง. — สรุปครบโดยทีมกฎหมาย Thai Notary Phuket",
    "category": "translation",
    "tldr": "NAATI = นักแปลรับรองรัฐบาลออสเตรเลีย ใช้สำหรับ visa/ราชการ Australia, NZ. MoJ = นักแปลที่ขึ้นทะเบียนกับศาลยุติธรรมไทย ใช้สำหรับเอกสารส่งศาล/ทะเบียนราษฎร์/MFA. คนละระบบ.",
    "updatedAt": "2026-06-03",
    "aName": "NAATI Translator",
    "bName": "MoJ Translator (ผู้แปลขึ้นทะเบียน)"
  },
  {
    "slug": "mfa-vs-apostille",
    "title": "MFA Legalization vs Apostille — ใช้แบบไหนตอนไหน",
    "metaTitle": "MFA vs Apostille 2026 — ต่างกันยังไง ใช้ตอนไหน",
    "metaDesc": "เทียบ MFA Legalization (กงสุลไทย) กับ Apostille (Hague) — เอกสารแบบไหนใช้ตอนไหน ราคา ระยะเวลา ประเทศที่รับ. — สรุปครบโดยทีมกฎหมาย Thai Notary Phuket",
    "category": "legalization",
    "tldr": "Apostille = single-step certification ใช้ระหว่างประเทศสมาชิก Hague (130+). MFA Legalization = certify โดย MFA + Embassy ปลายทาง สำหรับ non-Hague. ตั้งแต่ 28 ก.พ. 2570 ที่อนุสัญญามีผลกับไทย — เอกสารไปประเทศสมาชิกใช้ Apostille ขั้นตอนเดียวจบ.",
    "updatedAt": "2026-06-03",
    "aName": "MFA + Embassy Legalization",
    "bName": "Apostille (Hague Convention)"
  },
  {
    "slug": "marry-in-thailand-vs-abroad",
    "title": "จดทะเบียนสมรสในไทย vs ต่างประเทศ",
    "metaTitle": "จดทะเบียนสมรสไทย vs ต่างประเทศ — แบบไหนคุ้ม",
    "metaDesc": "เทียบจดทะเบียนสมรสในไทยกับต่างประเทศ (Vegas/Denmark/HK) — เอกสาร ราคา recognition สิทธิ Visa. — สรุปครบโดยทีมกฎหมาย Thai Notary Phuket",
    "category": "marriage",
    "tldr": "ในไทย = อำเภอจดให้ฟรี, ใช้ Affirmation + แปล + MFA. ต่างประเทศ = เอกสารน้อย อนุมัติเร็ว แต่ต้องนำกลับมา recognize ในไทย.",
    "updatedAt": "2026-06-03",
    "aName": "จดทะเบียนสมรสในไทย (อำเภอ)",
    "bName": "จดต่างประเทศ (Denmark/Vegas/HK)"
  },
  {
    "slug": "notary-public-vs-government-certification",
    "title": "Notary Public vs Government Certification",
    "metaTitle": "Notary Public vs Government Cert — เมื่อไรใช้อะไร",
    "metaDesc": "เทียบ Notary Public กับ Government Certification — ใครเป็นผู้รับรอง ใช้ตอนไหน เอกสารแบบไหนใช้ดวงไหน. — สรุปครบโดยทีมกฎหมาย Thai Notary Phuket",
    "category": "notary",
    "tldr": "Notary Public ไทย = ทนายผู้ได้รับรับรองจากสภาทนาย รับรองสำเนา/ลายมือชื่อ/คำแปล. Government Cert = ราชการไทย (อำเภอ/MFA) certify เอกสารราชการต้นฉบับ. ใช้คู่กัน.",
    "updatedAt": "2026-06-03",
    "aName": "Notary Public Attorney",
    "bName": "Government Certification"
  },
  {
    "slug": "thai-pcc-vs-international-pcc",
    "title": "Thai Police Clearance vs International PCC",
    "metaTitle": "Thai PCC vs International — ใช้ตัวไหนตอนไหน",
    "metaDesc": "เทียบ Thai PCC กับ International (FBI/ACRO/AFP/DBS) — ใช้ตัวไหนสำหรับ visa/work permit/PR. — สรุปครบโดยทีมกฎหมาย Thai Notary Phuket",
    "category": "notary",
    "tldr": "Thai PCC ออกโดย Royal Thai Police — prove ไม่มีประวัติในไทย. International PCC ออกโดยตำรวจประเทศต้นทาง — prove ในประเทศที่เคยอาศัย.",
    "updatedAt": "2026-06-03",
    "aName": "Thai Police Clearance Certificate",
    "bName": "International PCC (FBI/ACRO/AFP/DBS)"
  },
  {
    "slug": "certified-true-copy-vs-notarized-copy",
    "title": "Certified True Copy vs Notarized Copy",
    "metaTitle": "Certified True Copy vs Notarized Copy — ต่างยังไง",
    "metaDesc": "เทียบ Certified True Copy (CTC) กับ Notarized Copy — ใครเป็นผู้รับรอง ใช้ตอนไหน หน่วยงานใดยอมรับ. — สรุปครบโดยทีมกฎหมาย Thai Notary Phuket",
    "category": "notary",
    "tldr": "CTC = สำเนาที่ issuer (อำเภอ/MFA/BOI) รับรอง. Notarized Copy = Notary Public รับรอง. ส่วนใหญ่สลับกันได้ แต่บางหน่วยงาน (ศาล/Embassy เข้มงวด) ต้องการเฉพาะ CTC.",
    "updatedAt": "2026-06-03",
    "aName": "Certified True Copy (CTC)",
    "bName": "Notarized Copy"
  }
];

export function getCompareMeta(slug: string): CompareMeta | undefined {
  return COMPARE_META.find((c) => c.slug === slug);
}
